export const GOOGLE_MEASUREMENT_ID = 'G-JE41DB6K20'
export const defaultLanguage = 'en'
export const CompanyInitialName = 'Sankhyatronics'
export const BookingLink = 'https://outlook.office365.com/owa/calendar/ScheduleaCall@sankhyatronics.com/bookings/'
export const JobLink = 'https://www.linkedin.com/company/sankhyatronics/jobs'
export const PostLink = 'https://www.linkedin.com/company/sankhyatronics/posts'
export const CompanyAddress = 'F-9/478, Laxman Marg, Chitrakoot Scheme, Vaishali Nagar, Jaipur - 302021, Rajasthan, India'